import React from 'react';

export default function Flamingo() {
	// 13
	let style = {
		st16: {
			fill:"#E6E6E6"
		},
		st72: {
			fill:"#F79AC0"
		},
		st11: {
			fill:"#FCB47E"
		},
		st92: {
			fill:"#4D4D4D"
		},
		st0: {
			fill:"#FFFFFF"
		}
	};
	return (
		<g>
			<path style={style.st16} d="M94.4697266,317h-3.7587891l-30.1699219,85c0,0.4892578,1.1873779,0.8858643,2.6520996,0.8858643
				S65.6843262,402.4529419,65.8452148,402l26.7338867-75.4741211L119.1135254,402h-0.0043945
				c0,0.4892578,1.1873779,0.8858643,2.6520996,0.8858643s2.4912109-0.4329224,2.6520996-0.8858643L94.4697266,317z"/>
			<path style={style.st72} d="M98.2805176,297.7094727c-14.5054932,0-27.2381592,4.8192139-34.5026855,12.0799561
				c0.2424316-1.7472534,0.9230957-3.9546509,1.9088135-6.2649536c1.2149658-2.7724609,2.8181152-5.7300415,4.5479736-8.769043
				c1.7111816-3.0608521,3.6419678-6.1472778,5.6251221-9.3361206c1.9758301-3.2053223,4.088623-6.4439087,5.8814697-10.3455811
				c0.8883057-1.9550171,1.6849365-4.1037598,2.1738281-6.550415c0.1235352-0.633667,0.2421875-1.5952148,0.3032227-2.1421509
				l0.0672607-0.5961914l0.0168457-0.1484985l0.0083008-0.0742188l0.0042725-0.0370483l0.0089111-0.3678589l0.0224609-0.3826904
				c0.0682373-1.0106812,0.0789795-2.0561523,0.0762939-3.1102905c-0.0252686-2.1248169-0.2293701-4.3518066-0.7927246-6.699585
				c-0.5714111-2.336731-1.5384521-4.8060303-3.0776367-7.0773315c-1.5220947-2.2659912-3.5761719-4.2490234-5.7229004-5.635376
				c-2.1466064-1.4089355-4.31604-2.2921143-6.2619629-2.8299561c-3.9182129-1.1003418-6.9923096-1.0782471-9.3900146-0.9262695
				c-0.4006348,0.0372314-0.7750244,0.0889893-1.1376953,0.1464844c-6.7547607,0.5197754-12.0771484,6.1533203-12.0771484,13.0414429
				c0,7.230896,5.8616943,13.0927124,13.0926514,13.0927124c2.5100098,0,4.8466797-0.718811,6.8388672-1.9434814
				c0.0646973,0.1795654,0.1279297,0.3640747,0.1855469,0.5631714c0.1268311,0.480896,0.236084,0.9956055,0.3074951,1.5664062
				l0.0313721,0.2109985c0.0036621-0.1339111-0.0025635,0.3371582,0.0091553-0.2935181l0.0014648,0.0372925l0.0029297,0.074585
				l0.0058594,0.149292l0.0234375,0.5994873c0.0053711,0.1391602,0.0041504,0.1130981,0.0064697,0.1258545l0.010498,0.0285645
				c0.0042725,0.0367432,0.0372314,0.0028076,0.0336914,0.1027222c0.0096436,0.7556763-0.1369629,1.7960205-0.4637451,2.9730835
				c-0.6529541,2.3704224-2.0212402,5.1851807-3.7711182,7.9677734c-1.7575684,2.7996216-3.8709717,5.6384277-6.0997314,8.5700073
				c-2.2073975,2.953064-4.4627686,6.0525513-6.5540771,9.520813c-2.0975342,3.4634399-4.1464844,7.2816772-5.3341064,12.0498047
				c-0.5737305,2.3739014-0.9296875,4.9903564-0.8258057,7.7250366c0.0968018,2.7267456,0.6878662,5.5411987,1.6911621,8.0528564
				c0.9957275,2.5217285,2.3438721,4.7219849,3.7398682,6.5702515c1.4053955,1.8432007,2.8817139,3.4005127,4.3132324,4.6986694
				c2.8843994,2.6035767,5.5441895,4.4031372,7.8936768,5.8674316c2.3574219,1.4473877,4.3635254,2.5170288,6.0367432,3.3847656
				c1.6601562,0.8258667,5.2386475,2.381958,5.2386475,2.381958l0,0c5.4729004,2.6133423,12.3459473,4.1355591,20.4851074,4.1355591
				c22.5944824,0,33.5958252-25.8887329,51.748291-31.5119019C162.7626953,312.7608032,120.875,297.7094727,98.2805176,297.7094727z"
				/>
			<path style={style.st11} d="M46.1955338,254.1526031c-1.3502197,0.9560242-10.6007614,10.998642-1.1788139,17.6878815
				l9.4721756-7.883606L46.1955338,254.1526031z"/>
			<circle style={style.st0} cx="59.0552216" cy="251.6837616" r="6.1673884"/>
			<circle style={style.st92} cx="59.0552216" cy="251.6837616" r="2.9245703"/>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Flamingo.js